import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable, Field } from '../../commons/DataTable';
import BooleanFieldMarketing from '../../commons/DataTable/BooleanFieldMarketing';
import ActionsField from './ActionsField';

function ContactsTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  profile,
  updateContacts,
}) {
  const [t] = useTranslation('MARKETING');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field title="Nome" source="nome" className="text-left" />
      <Field title="Cognome" source="cognome" className="text-left" />
      <BooleanFieldMarketing title="Azienda" source="azienda" />
      <Field title="Nome Azienda" source="nome_azienda" className="text-left" />
      <Field title="Email" source="email" />
      <Field title="Telefono" source="telefono" />
      <Field title="CAP" source="cap" />
      <Field title="Provincia" source="provincia" />
      <Field title="Cittá" source="citta" />
      <BooleanFieldMarketing
        title="Consenso termini e condizioni"
        source="consenso_termini_condizioni"
      />
      <BooleanFieldMarketing
        title="Consenso privacy"
        source="consenso_privacy"
      />
      <BooleanFieldMarketing
        title="Consenso marketing"
        source="consenso_marketing"
      />
      <BooleanFieldMarketing
        title="Consenso terze parti"
        source="consenso_terze_parti"
      />
      <ActionsField
        title="Azioni"
        updateContacts={updateContacts}
        profile={profile}
        data={data}
      />
    </DataTable>
  );
}

export default ContactsTable;
